module.exports = __webpack_public_path__ + "static/ZenithSlabDJRColor-Regular-bb1e441fa6284273d667c1216f6d87e8.woff2";